import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { useToast } from "../theme/components";

/**
 * Guard for admin-only routes. Mirrors ``ProtectedRoute`` but also
 * checks ``user.role === "admin"``; non-admins are bounced to the
 * dashboard with a toast.
 */
export default function AdminRoute({ children }) {
    const { isAuthenticated, isLoading, user } = useAuth();
    const location = useLocation();
    const toast = useToast();
    const redirectedRef = React.useRef(false);

    if (isLoading) {
        return (
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100vh",
                }}
            >
                <div className="spinner" />
            </div>
        );
    }

    if (!isAuthenticated) {
        const next = encodeURIComponent(location.pathname + location.search);
        return <Navigate to={`/login?next=${next}`} replace />;
    }

    if (user?.role !== "admin") {
        if (!redirectedRef.current) {
            redirectedRef.current = true;
            toast.error("Admin access required.");
        }
        return <Navigate to="/dashboard" replace />;
    }

    return children;
}
